import translations from './const/uz_cyrl.json';

const uz_cyrl = {
  translation: {
    ...translations
  }
}

export default uz_cyrl;